export default __webpack_public_path__ + "static/media/garden-icon.6e1a5382.svg";